import Vue from 'vue'
import GSignInButton from 'vue-google-signin-button'

Vue.use(GSignInButton)



// WEBPACK FOOTER //
// ./resources/js/plugins/googlesign.js